


























































































































































































































































































































































































































































































































































































































































































































































































































import {
  defineComponent,
  useAsync,
  useContext,
  useRoute,
  reactive,
  ref
} from '@nuxtjs/composition-api'
import { AxiosError } from 'axios'
import useCookies from '~/composables/useCookies'
import useFlashMessage from '~/composables/useFlashMessage'
import FaqAccordion from '~/components/entry/FaqAccordion.vue'
import Meta from '~/assets/mixins/meta'
import Modal from '~/components/Modal.vue'
import Turnstile from '~/components/Turnstile.vue'
import useProfileApis from '~/composables/careers/useProfileApis'
import useSessionId from '~/composables/useSessionId'
import useA8netAffiliateApis from '~/composables/useA8netAffiliateApis'

export default defineComponent({
  layout: 'none',
  mixins: [Meta],
  components: {
    FaqAccordion,
    Modal,
    Turnstile
  },
  data() {
    return {
      meta: {
        title: 'Vookキャリアはじめての方へ | Vookキャリア',
        image: require('~/assets/images/career/ogp.jpg')
      }
    }
  },
  setup() {
    const { $axios, $auth, redirect } = useContext()
    const route = useRoute()
    const $cookies = useCookies()
    const { showFlashNoticeMessage, showFlashAlertMessage } = useFlashMessage()
    const { fetchProfile } = useProfileApis()
    const { getSessionId, getOrCreateSessionId } = useSessionId()
    const { createA8netAffiliate } = useA8netAffiliateApis()

    const input = reactive({
      email: '',
      password: '',
      agreement: false,
      career_agreement: false
    })

    const loading = ref(false)
    const turnstileTop = ref<InstanceType<typeof Turnstile>>()
    const turnstileFooter = ref<InstanceType<typeof Turnstile>>()
    const turnstileModal = ref<InstanceType<typeof Turnstile>>()
    const turnstileToken = ref('')

    const onTurnstileVerify = (token: string) => {
      turnstileToken.value = token
    }

    const resetTurnstile = () => {
      turnstileToken.value = ''
      turnstileTop.value?.reset()
      turnstileFooter.value?.reset()
      turnstileModal.value?.reset()
    }

    const onTurnstileError = (type: 'load' | 'verify') => {
      resetTurnstile()
      showFlashAlertMessage(
        type === 'load'
          ? '読み込みに失敗しました。再度お試しください。'
          : '確認に失敗しました。再度お試しください。'
      )
    }

    const removeJobsPageCookie = () => {
      $cookies.remove('jobsPage')
    }

    const register = () => {
      loading.value = true
      const sessionId = getSessionId()
      const params = {
        ...input,
        turnstile_token: turnstileToken.value,
        ...(sessionId ? { session_id: sessionId } : {})
      }
      $axios
        .$post('/register/account', params)
        .then(() => {
          showFlashNoticeMessage(
            '本人確認用のメールを送信しました。メール内のリンクからアカウントを有効化させてください。'
          )
          $cookies.set(
            'afterLoginURL',
            `${process.env.BASE_URL}/registration`,
            {
              domain: process.env.COOKIE_DOMAIN
            }
          )
          $cookies.set('registrationEmail', input.email)
          redirect('/sign_up/complete')
        })
        .catch((e: AxiosError<string[]>) => {
          loading.value = false
          showFlashAlertMessage(e.response!.data.join('<br>'))
          resetTurnstile()
        })
    }

    useAsync(() => {
      if ($auth.loggedIn && $auth.user?.career_agreement) {
        redirect('/')
      }
    })

    // SSR時にCookieをサーバー発行(Set-Cookie)させるため、onMountedではなくuseAsyncで実行する
    useAsync(() => {
      const a8Param = route.value.query.a8
      if (typeof a8Param !== 'string' || !a8Param) {
        return
      }

      const sessionId = getOrCreateSessionId()
      createA8netAffiliate(a8Param, sessionId).catch(() => {
        // トラッキング失敗はLP表示をブロックしない
      })
    })

    return {
      input,
      loading,
      turnstileTop,
      turnstileFooter,
      turnstileModal,
      turnstileToken,
      onTurnstileVerify,
      onTurnstileError,
      register,
      removeJobsPageCookie
    }
  },
  methods: {
    openModal(name: string) {
      this.$modal.show(name)
    }
  }
})
